import { render, staticRenderFns } from "./ProductOnlineDoc.vue?vue&type=template&id=0ddf8290&scoped=true&"
import script from "./ProductOnlineDoc.vue?vue&type=script&lang=js&"
export * from "./ProductOnlineDoc.vue?vue&type=script&lang=js&"
import style0 from "./ProductOnlineDoc.vue?vue&type=style&index=0&id=0ddf8290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf8290",
  null
  
)

component.options.__file = "ProductOnlineDoc.vue"
export default component.exports